<template>
  <div>
    {{aa}}
  </div>
</template>
<script>
export default {
  data() {
    return {
      aa:'1212'
    }
  },
  mounted() {
    
  },

  methods: {

  },
}
</script>
<style>

</style>
